import { configureStore, combineReducers } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
} from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage

// Reducers
import settingReducer from "./setting/reducers";
import UserReducer from "./user/userSlice";
import instagramReducer from "./instagram/instagramSlice";
import facebookReducer from "./facebook/facebookSlice";
import whatsappReducer from "./whatsApp/wpSlice";
import cloudinaryReducer from "./Cloudinary/CloudinarySlice";
import FaqsReducer from "./faqs/faqsSlice";
import contactReducer from "./contact/contactSlice";
import helpReducer from "./help/helpSlice";
import telegramReducer from "./telegram/telegramSlice";
import QuickreplyReducer from "./Quickreply/quickreplySlice";
import templateReducer from "./template/TemplateSlice";
import chartReducer from "./chart/chartSlice";
import googleReducer from "./google/googleSlice";
import scheduleReducer from "./schedule/scheduleSlice";
import subscriptionReducer from "./subscription/subscriptionSlice";

// Combine all reducers
const rootReducer = combineReducers({
  setting: settingReducer,
  userservice: UserReducer,
  instagram: instagramReducer,
  facebook: facebookReducer,
  cloudinary: cloudinaryReducer,
  Faqs: FaqsReducer,
  whatsapp: whatsappReducer,
  subscription: subscriptionReducer,
  contact: contactReducer,
  help: helpReducer,
  telegram: telegramReducer,
  Quickreply: QuickreplyReducer,
  template: templateReducer,
  chart: chartReducer,
  google: googleReducer,
  scheduler: scheduleReducer,
});

// Redux Persist configuration
const persistConfig = {
  key: "root",
  storage,
};

// Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    }),
});

// Create the persistor
export const persistor = persistStore(store);
